import React from "react";
import UnifiedLessonViewer from "../../../components/lesson/UnifiedLessonViewer";

const LessonRead = () => {
    return <UnifiedLessonViewer />;
};

export default LessonRead;
